import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/display.actions';
import * as home from '../../../../actions/process.home.actions';
import * as inventory from '../../../../actions/process.inventory.actions';

import Fab from '@material-ui/core/Fab';
import Hidden from '@material-ui/core/Hidden';

import Menu from '../Menu';
import FilterMenu from './FilterMenu';
import List from './List';
import Error from '../../../dialogs/Error';
import { AddIcon, FilterIcon } from '../../../../images/icons/WrapSvg';

function toolbar(handleFilter, secondary = false) {
    const color = secondary ? 'secondary' : 'primary';
    return <FilterIcon key={'filter-menu-toolbar'} color={color} onClick={handleFilter} />;
}

class Displays extends React.Component {
    state = {
        hide: false,
        open: undefined,
        local: undefined,
        status: undefined,
        loading: true
    };

    constructor(props) {
        super(props);
        props.loadDisplays(undefined, true);

        const tools = [toolbar(this.handleFilter)];
        this.props.setTools(tools);
        this.props.setSearch(true);
        this.interval = setInterval(() => {
            this.props.loadDisplays(undefined, false);
        }, 5000);
    }

    componentDidMount() {
        this.props.setInventoryWindow("displays");
        this.setState({ loading: false });
    }

    componentWillUnmount() {
        this.props.setTools([]);
        this.props.setSearch(false);
        clearInterval(this.interval);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.displays_has_error) {
            this.setState({
                hide: false,
                open: undefined,
                local: undefined,
            });
            nextProps.props.loadDisplays(undefined);
        }
    }

    handleFilter = (event) => {
        this.setState({ open: event.currentTarget });
    };

    handleCloseMenu = (status) => {
        if (status === null) {
            this.setState({ open: undefined });
        } else {
            const tools = [toolbar(this.handleFilter, status === '1' || status === '2')];
            this.props.setTools(tools);
            this.setState({ open: undefined, status: status });
        }
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleClick = (event) => {
        this.props.history.push('/manage/new_display');
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info } = this.props;
        const { open, status, loading } = this.state;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '80') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            const superadmin = info &&
                info.security &&
                info.security.totalPermits &&
                info.security.totalPermits.some((f) => f === '20');
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={5} />
                        </div>
                    </Hidden>
                    <div className={'flex_full'}>
                        <div className={'flex_full overflow_y_scroll center height100 bg_ice_blue showbar'}>
                            <List search={[...this.props.window_searchs]} loading={loading} superadmin={superadmin} status={status} />
                            <Fab
                                color="primary"
                                aria-label="add"
                                className={'button_float'}
                                onClick={this.handleClick}
                            >
                                <AddIcon />
                            </Fab>
                        </div>
                    </div>
                    {open && (
                        <FilterMenu
                            anchorEl={open}
                            status={status}
                            handleClose={this.handleCloseMenu.bind(this)}
                        />
                    )}
                </div>
            );
        }
    }
}

Displays.propTypes = {
    displays_is_loading: PropTypes.bool.isRequired,
    displays_has_errored: PropTypes.object.isRequired,
    window_searchs: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
    return {
        displays_is_loading: state.displays_is_loading,
        displays_has_errored: state.displays_has_errored,
        window_searchs: state.window_searchs,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home, inventory), dispatch);
};

Displays = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Displays);

Displays = withRouter(Displays);

export default Displays;



// WEBPACK FOOTER //
// ./src/components/complex/manage/displays/Index.js